import React from 'react'
import Modal from 'jd-library/Modal'
import style from "./index.scss";
import Button from "../../Button/Button";

const DontDealModel = ({ title, onHidden, removeCatBtn }) => {
    return (
        <Modal
            settings={{
                modalId: 'dont-deal-category',
                class: 'dont-deal-container',
            }}
            onHidden={onHidden}>
                <div className="modelContainer">
            <Modal.CloseIcon />
            <Modal.Header>
                Remove {title}
            </Modal.Header>
            <Modal.Body className="modal-body">
                <div>
                    Are you sure you want to remove {title} from your business? This will remove {title} from your business profile as well.
                </div>
            </Modal.Body>
            <div className="btnContainer">
                <Button
                    variant="primary"
                    className={"btnClass"}
                    disableRipple
                    clickHandler={removeCatBtn}>
                    Yes, Remove Category
                </Button>
                <Button
                    variant="default"
                    className={"btnClass"}
                    disableRipple
                    clickHandler={onHidden}>
                    Don't Remove Category
                </Button>
            </div>
            </div>
        </Modal>
    )
}

export default DontDealModel